import { Component } from 'react'
import { StylewherePage, DefaultHeader, Section, GridData, NotFound } from '../../../components'
import { StwBalance, DetailCell } from '../../../api'
import { __, T } from '../../../shared/i18n'
import { ExtendRouteComponentProps } from '../../../types'
import Balances from '../../../api/Balances'
import { BALANCES_DATA } from '../../../config/Pages/Devices/Balances'
import {
  getDetailDataWithAttributesMapping,
  getMultipleTitle,
  getBackURL,
  getFragmentObject,
} from '../../../shared/utils'

interface State {
  balance: StwBalance | undefined
  loader: boolean
  detailData: DetailCell[]
}

class BalanceDetail extends Component<ExtendRouteComponentProps, State> {
  constructor(props) {
    super(props)
    this.state = {
      balance: undefined,
      loader: true,
      detailData: BALANCES_DATA,
    }
  }

  componentDidMount = async () => {
    let balance
    const data: DetailCell[] = await getDetailDataWithAttributesMapping(BALANCES_DATA, 'scale', 2)
    if (this.props.match) {
      const balanceId = this.props.match.params.balanceId
      if (balanceId) {
        balance = await Balances.get<StwBalance>(balanceId).then((res) => res)
      }
    }

    this.setState({
      balance: balance,
      detailData: data,
      loader: false,
    })
  }

  render() {
    const { balance, loader, detailData } = this.state
    const { breadcrumbs, queryString } = this.props
    const fragment = getFragmentObject(balance, 'code')
    return (
      <StylewherePage {...this.props} noOverflow fragment={fragment}>
        <DefaultHeader
          backPath={getBackURL(queryString, breadcrumbs)}
          multipleTitle={getMultipleTitle(balance)}
          title={__(T.misc.not_found)}
          skeleton={{ active: loader, options: { multiple: true } }}
        />
        <Section customClass={`stw-section-page paged-header ${balance || loader ? 'scroll transparent' : ''}`}>
          {balance || loader ? (
            <GridData fields={detailData || BALANCES_DATA} record={balance || {}} skeleton={loader} />
          ) : (
            <NotFound fullheight title={__(T.misc.noRecordFoundTitle)} />
          )}
        </Section>
      </StylewherePage>
    )
  }
}

export default BalanceDetail
